import { atom, selector } from 'recoil';
import { FleetServiceStatus } from '../types/fleet';

export const fleetAssetServicesReloadListState = atom<boolean>({
  key: 'app.fleet.assetServices.reload',
  default: false,
});

export const fleetAssetServicesFiltersState = atom<{
  page: number;
  assetId?: string;
  configurationId?: string;
  status?: FleetServiceStatus;
}>({
  key: 'app.fleet.assetServices.filters',
  default: {
    page: 1,
    assetId: undefined,
    configurationId: undefined,
    status: undefined,
  },
});

export const fleetAssetServicesHasAnyFilterState = selector<boolean>({
  key: 'app.fleet.assetServices.filters.any',
  get: ({ get }) => {
    const filters = get(fleetAssetServicesFiltersState);
    const hasConfigurationIdFilter = filters.configurationId !== undefined;
    const hasStatusFilter = filters.status !== undefined;

    return hasConfigurationIdFilter || hasStatusFilter;
  },
});
